import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {BsModalService} from 'ngx-bootstrap/modal';
import {ModalBonusComponent} from '../../../../resources/components/modals/modal-bonus/modal-bonus.component';

@Component({
  selector: 'user-view-purchases',
  templateUrl: './user-view-purchases.component.html'
})
export class UserViewPurchasesComponent implements OnInit {

  id: any = this.route.parent.snapshot.params.id;

  constructor(private route: ActivatedRoute,
              private modalService: BsModalService) { }

  ngOnInit(): void {
  }

  addPurchase() {
    this.modalService.show(ModalBonusComponent, {
      initialState: {
        user: this.id
      },
      backdrop: 'static'
    })
  }

}
